// extracted by mini-css-extract-plugin
export default {"container":"errors_container__yT0VZ","title":"errors_title__dbkW3","text":"errors_text__d+VZE","button":"errors_button__Vrme4"};